export const serviceCategories = [
  {
    id: 'lawn_services',
    name: 'Lawn Care & Mosquito Control',
    description: 'Yard Size (sq ft) | 0 - 5000 | Front/Back Yard Only',
    services: [
      {
        service_id: 'lawn_services',
        id: 'aeration',
        name: 'Aeration',
        description: 'Improve your lawn health with core aeration to reduce soil compaction',
        icon: 'aeration',
        benefits_copy: `Core Aeration: The foundation of a healthy lawn
Aeration relieves soil compaction and allows your lawn to breathe again.
Benefits:
Improves airflow, water, and nutrient absorption


Promotes deeper, stronger root growth


Increases drought resistance and overall lawn health


🗓 Best Timing: Spring & Fall
 🤝 Best Paired With: Fertilization, Revive
⚡ Good to know:
Recommended 2x per year


Spring and fall windows fill quickly`,
        benefits_video: '8mcKazmcQ7Y',
        duration: 60,
        price: 75
      },
      {
        service_id: 'lawn_services',
        id: 'double_pass_aeration',
        name: 'Double-Pass Aeration',
        description: 'Intensive aeration with double coverage for heavily compacted soil',
        icon: 'double_pass_aeration',
        benefits_copy: `Maximum relief for heavily compacted lawns
Double-pass aeration provides deeper, more thorough soil relief for lawns that need extra attention.
Benefits:
Increased hole density for better soil penetration


More effective for high-traffic or clay-heavy lawns


Maximizes results from fertilization and overseeding


🗓 Best Timing: Spring & Fall
 🤝 Best Paired With: Fertilization, Revive
⚡ Good to know:
Ideal for heavily compacted or struggling lawns


Limited seasonal availability

`,
        benefits_video: '-iJjqtte6T0',
        duration: 90,
        price: 140
      },
      {
        service_id: 'lawn_services',
        id: 'fertilization_feed_only',
        name: 'Fertilization',
        description: 'Professional lawn fertilization for a greener, healthier yard',
        icon: 'fertilization_feed_only',
        benefits_copy: `Consistent nutrition for a greener, stronger lawn
Your lawn needs ongoing nutrients to stay healthy and vibrant.
Benefits:
Promotes thick, green, and uniform growth


Strengthens turf against heat and drought stress


Improves long-term lawn health and resilience


🗓 Best Timing: Throughout the growing season
 🤝 Best Paired With: Aeration, Revive
⚡ Good to know:
Best results come from 4 applications per season


Consistency is key for long-term results

`,
        benefits_video: 'OfOYsqcyI4Q',
        duration: 45,
        price: 85
      },
      {
        service_id: 'lawn_services',
        id: 'weed_pre',
        name: 'Weed Control: Pre-Emergent',
        description: 'Stop weeds before they start. Prevent crabgrass and other annual weeds from ever taking hold in your lawn.',
        icon: 'weed_pre',
        benefits_copy: `Stop weeds before they start
 Prevent crabgrass and other annual weeds from ever taking hold in your lawn.
Benefits:
Prevents weed seeds from germinating
Reduces weed pressure throughout the season
Helps your lawn stay cleaner and more uniform
🗓 Best Timing: Early Spring (before soil warms up)
 🤝 Best Paired With: Fertilization, Post-Emergent Weed Control
⚡ Good to know:
Pre-emergent prevents new weeds — it does not kill existing ones
Watering after the application is a good thing. Water is what activates the product and carries it down into the soil where the barrier forms.
Hold off on mowing for 24 hours after the application so the soil and the barrier aren't disturbed
Timing is critical — once weeds sprout, it’s too late
Not compatible with overseeding (blocks grass seed germination)
Spring window is short and fills quickly
`,
        benefits_video: 'vpwHe84Lpx8',
        duration: 8,
        price: 125
      },
      {
        service_id: 'lawn_services',
        id: 'weed_post',
        name: 'Weed Control: Post-Emergent',
        description: 'Eliminate weeds that are already growing. Target and control broadleaf weeds like dandelions, clover, and thistle.',
        icon: 'weed_post',
        benefits_copy: `Eliminate weeds that are already growing
 Target and control broadleaf weeds like dandelions, clover, and thistle.
Benefits:
Kills visible weeds at the source
Improves lawn appearance quickly
Helps prevent weeds from spreading further
🗓 Best Timing: Spring through early Fall (while weeds are actively growing)
 🤝 Best Paired With: Fertilization, Pre-Emergent (next season), Aeration
⚡ Good to know:
Works best on actively growing weeds
Results typically visible within 7–14 days
Avoid mowing 24 hours before and after treatment
Multiple treatments may be needed for full control
`,
        benefits_video: 'HEcQu_2Jgrs',
        duration: 8,
        price: 125
      },
      // {
      //   service_id: 'lawn_services',
      //   id: 'fertilization_weed_feed',
      //   name: 'Fertilization: Weed+Feed',
      //   description: 'Combination fertilization and weed control treatment',
      //   icon: 'Leaf',
      //   duration: 60,
      //   price: 125
      // },
      {
        service_id: 'lawn_services',
        id: 'revive',
        name: 'Revive',
        description: 'Soil conditioner to improve water penetration and reduce watering needs',
        icon: 'revive',
        benefits_copy: `Improve your soil to improve your lawn
Revive enhances your soil’s ability to absorb and retain water.
Benefits:
Improves water penetration in clay soils


Reduces runoff and dry spots


Enhances root development and drought tolerance


🗓 Best Timing: Late Spring & Summer
 🤝 Best Paired With: Aeration, Fertilization
⚡ Good to know:
Especially beneficial during heat and drought stress


Works below the surface for long-term results

`,
        benefits_video: 'hnuZBFM365k',
        duration: 45,
        price: 85
      },
      {
        service_id: 'lawn_services',
        id: 'overseed',
        name: 'Overseed',
        description: 'Overseed your lawn to fill in bare spots and thicken grass',
        icon: 'overseed',
        benefits_copy: `Thicken your lawn and fill in bare areas
Overseeding introduces new grass to improve density and appearance.
Benefits:
Fills in thin or patchy areas


Improves lawn thickness and uniformity


Helps naturally prevent future weed growth


🗓 Best Timing: Fall (ideal), Spring (limited)
 🤝 Best Paired With: Fertilization, Revive
⚡ Good to know:
Includes double-pass aeration for best results


Not compatible with recent pre-emergent


Requires consistent watering after service


Fall is the best window and fills quickly

`,
        benefits_video: 'XTf6MYnrnJk',
        duration: 90,
        price: 200
      },
      {
        service_id: 'lawn_services',
        id: 'mosquito_control',
        name: 'Mosquito Control - Botanical',
        description: 'Targeted plant-based treatment of mosquito resting areas.',
        icon: 'mosquito_control',
        benefits_copy: `Get your evenings back.
Mosquitoes don't roam your yard all day — they rest in the shaded, humid places in your landscape. We find those areas, treat them with a plant-based product using a professional backpack mister.

Benefits:
Fewer mosquitoes in the areas where you actually sit, cook, and play
Targeted application to resting areas and harborage, not blanket-sprayed across your lawn

🗓 Best Timing: Late spring through first frost. In Colorado, activity typically peaks July through September. Treatments are recommended on a 21-day cycle through October.

🤝 Best Paired With: Yard Cleanup (removes leaf litter and debris that hold moisture), Detail Maintenance (thins the dense shrub interiors mosquitoes rest in), and any drainage or grading work to eliminate standing water.

⚡Good to Know:
Plant-based products are strongest in the first week or two and taper after that. That's why we recommend treating every 21 days rather than monthly.
We don't treat plants that are in bloom, and we keep our application off flowering material to reduce impact on pollinators.
We treat resting and harborage areas: shaded beds, shrub interiors, fence lines, under decks and low structures, and the perimeter. We don't blanket-treat open lawns.
2026 is à la carte only. Recurring seasonal packages are coming for 2027.
Standing water on your property is the single biggest driver of mosquito numbers. We'll identify it and note it on your completion report — removing it is the highest-impact thing you can do.

`,
        benefits_video: 'Aqhb3YAGHnE',
        duration: 30,
        price: 125
      },
    ],
  },
  {
    id: 'irrigation_services',
    name: 'Irrigation Services',
    description: 'Zones | up to 10',
    services: [
      {
        service_id: 'irrigation_services',
        id: 'sprinkler_activation',
        name: 'Sprinkler Activation',
        description: 'Professional spring startup of your irrigation system',
        icon: 'sprinkler_activation',
        benefits_copy: `Start your irrigation system safely and efficiently
Proper activation protects your system and ensures optimal performance.
Benefits:
Prevents damage from improper startup


Identifies leaks or issues early


Ensures proper coverage and functionality


🗓 Best Timing: Early Spring
 🤝 Best Paired With: System Upgrades, Follow-up Audits
⚡ Good to know:
Required to maintain Freeze Free Warranty


Includes system inspection and timer programming


Spring scheduling fills quickly

`,
        benefits_video: 'gI92jX1Zh4k',
        duration: 60,
        price: 90,
      },
      {
        service_id: 'irrigation_services',
        id: 'sprinkler_winterization',
        name: 'Sprinkler Winterization',
        description: 'Protect your irrigation system from freeze damage',
        icon: 'sprinkler_winterization',
        benefits_copy: `Protect your system from costly freeze damage
Winterization removes water from your system before freezing temperatures hit.
Benefits:
Prevents cracked pipes, valves, and fittings


Protects your home and landscape from water damage


Ensures system is safe through winter


🗓 Best Timing: Fall (before first hard freeze)
 🤝 Best Paired With: Spring Activation
⚡ Good to know:
Includes Freeze Free Warranty (with activation)


Must be completed before freezing temps


Fall schedule fills fast

`,
        benefits_video: 'XWp25fxWDTE',
        duration: 45,
        price: 90,
      },
      {
        service_id: 'irrigation_services',
        id: 'sprinkler_audit',
        name: 'Sprinkler Audit',
        description: 'Comprehensive inspection and optimization of your irrigation system',
        icon: 'sprinkler_audit',
        benefits_copy: `Understand exactly how your irrigation system is performing
A full system check to identify issues and improve efficiency.
Benefits:
Detects leaks, inefficiencies, and coverage issues


Improves water efficiency and lawn health


Provides expert recommendations for improvements


🗓 Best Timing: Mid-Season or when issues arise
 🤝 Best Paired With: Smart timer & water efficient head upgrades
⚡ Good to know:
Audit fee is applied toward approved repairs


Ideal if you notice dry spots or high water bills

`,
        benefits_video: 'bVfikmtAxBI',
        duration: 90,
        price: 90,
      },
    ],
  },
  {
    id: 'yard_cleanup',
    name: 'Yard Cleanup',
    description: 'Complete yard cleanup including leaf removal and debris clearing',
    services: [
      {
        service_id: 'yard_cleanup',
        id: 'yard_cleanup',
        name: 'Yard Cleanup',
        description: 'Select the number of man hours needed for your cleanup',
        icon: 'yard_cleanup',
        benefits_copy: `Reset your landscape for a healthier season
Remove debris and maintain plant health with a professional cleanup.
Benefits:
Prevents disease and pest buildup


Improves lawn and plant health


Leaves your property clean and well-maintained


🗓 Best Timing: Spring & Fall
 🤝 Best Paired With: Mulch refresh, Fertilization, Power Rake
⚡ Good to know:
Service is billed in 2 Man-Hour blocks


Man-Hours = crew size × time onsite


Only pay for time that is used


Spring and fall slots fill quickly

`,
        benefits_video: 'nNiLE61nGME',
        duration: 120,
        tiers: [
          { id: 'cleanup_2hr', label: '2 Man Hours', price: 210 },
          { id: 'cleanup_4hr', label: '4 Man Hours', price: 370 },
          { id: 'cleanup_6hr', label: '6 Man Hours', price: 580 },
          { id: 'cleanup_8hr', label: '8 Man Hours', price: 790 },
          { id: 'cleanup_10hr', label: '10 Man Hours', price: 950 },
          { id: 'cleanup_12hr', label: '12 Man Hours', price: 1160 },
          // { id: 'cleanup_14hr', label: '14 Man Hours', price: 1320 },
          // { id: 'cleanup_16hr', label: '16 Man Hours', price: 1480 },
        ],
      }
    ],
  },
  {
    id: 'power_rake',
    name: 'Power Raking',
    description: 'Remove thatch buildup and prepare lawn for new growth',
    services: [
      {
        service_id: 'power_rake',
        id: 'power_rake',
        name: 'Power Rake',
        description: 'Remove thatch buildup and prepare lawn for new growth',
        icon: 'power_rake',
        benefits_copy: `Remove excess thatch and restore lawn performance
Power raking removes buildup that blocks nutrients from reaching your soil.
Benefits:
Improves water, air, and nutrient penetration


Promotes healthier, more vigorous growth


Prepares lawn for fertilization and overseeding


🗓 Best Timing: Early Spring
 🤝 Best Paired With: Fertilization, Overseeding
⚡ Good to know:
Best for lawns with heavy thatch buildup


Not a leaf cleanup service (yard must be clear prior)


Lawn may appear thin immediately after — this is normal


Very limited seasonal window
`,
        benefits_video: 'J5Y5AwJM9Ro',
        duration: 120,
        price: 200
      },
    ]
  }
];

export const serviceInstructions = {
  mosquito_control: {
    name: 'Mosquito Control - Botanical',
    title: "Before your Botanical Mosquito Control visit:",
    items: [
      "Unlock all gates. If we can't access the yard, we have to reschedule.",
      "WBring pets inside and pick up food and water bowls.",
      "Clear the patio — toys, cushions, the grill cover, birdfeeders, anything you'd rather we work around.",
      "Mow one to two days before if your schedule allows. Shorter turf improves access to resting areas.",
      "Tell us about any area to avoid — a vegetable garden, a pollinator bed, a fish pond. ",
    ],
    videoId: ""
  },
  aeration: {
    name: 'Aeration',
    title: "Prepare for Your Aeration Service",
    items: [
      "Mark all sprinkler heads",
      "Water your lawn the night before or morning of service",
      "Remove pet waste, toys, and debris from the lawn",
      "Unlock gates for yard access",
      "Mow lawn prior to service if possible",
    ],
    videoId: "szACb5o7LSY"
  },
  double_pass_aeration: {
    name: 'Double-Pass Aeration',
    title: "Prepare for Your Double-Pass Aeration Service",
    items: [
      "Mark all sprinkler heads",
      "Water your lawn the night before or morning of service",
      "Remove pet waste, toys, and debris from the lawn",
      "Unlock gates for yard access",
      "Mow lawn prior to service if possible",
    ],
    videoId: "szACb5o7LSY"
  },
  fertilization_feed_only: {
    name: 'Fertilization',
    title: "Prepare for Your Fertilization Service",
    items: [
      "Remove pet waste, toys, and debris from the lawn",
      "Unlock gates to allow access to service areas",
      "Secure pets indoors during application"
    ],
    videoId: "4ur7mtVqTQ8"
  },
  fertilization_weed_feed: {
    name: 'Fertilization',
    title: "Prepare for Your Fertilization Service",
    items: [
      "Remove pet waste, toys, and debris from the lawn",
      "Unlock gates for yard access",
      "Avoid mowing 24 hours before service (helps weed control effectiveness)",
      "Water your lawn the night before or morning of service",
      "Secure pets indoors during application",
    ],
    videoId: "6GQ7sV2U38w"
  },
  revive: {
    name: 'Revive',
    title: "Prepare for Your Revive Service",
    items: [
      "Remove pet waste, toys, and debris from the lawn",
      "Unlock gates for yard access",
      "Secure pets indoors during application"
    ],
    videoId: "RZmX83HGsv4"
  },
  overseed: {
    name: 'Overseeding',
    title: "Prepare for Your Overseeding Service",
    items: [
      "Mow lawn shorter than normal prior to service",
      "Remove pet waste, toys, and debris from lawn",
      "Mark all sprinkler heads",
      "Unlock gates for yard access",
      "Ensure lawn has not recently received pre-emergent weed control",
    ],
    videoId: "EzXZAnuovV4"
  },
  sprinkler_activation: {
    name: 'Sprinkler Activation',
    title: "Prepare for Your Sprinkler Activation",
    items: [
      "Someone over age 18 must be home",
      "Ensure access to irrigation timer/controller",
      "Ensure access to sprinkler shutoff valve (usually in basement)",
      "Unlock gates to allow access to yard"
    ],
    videoId: "1FecKJJsZgY"
  },
  sprinkler_winterization: {
    name: 'Sprinkler Winterization',
    title: "Prepare for Your Sprinkler Winterization",
    items: [
      "Someone over age 18 must be home",
      "Ensure access to irrigation timer/controller",
      "Ensure access to sprinkler shutoff valve (usually in basement)",
      "Unlock gates to allow access to yard"
    ],
    videoId: "rDyxj7EHXzo"
  },
  sprinkler_audit: {
    name: 'Sprinkler Audit',
    title: "Prepare for Your Sprinkler Audit",
    items: [
      "Someone over age 18 must be home",
      "Ensure access to irrigation timer/controller",
      "Ensure access to sprinkler shutoff valve (usually in basement)",
      "Unlock gates to allow access to yard"
    ],
    videoId: "_OQmOcwZi8o"
  },
  yard_cleanup: {
    name: 'Yard Cleanup',
    title: "Prepare for Your Yard Cleanup Service",
    items: [
      "Unlock gates to allow crew access",
      "Remove any personal items from work areas",
      "Identify any priority areas you’d like addressed",
      "Ensure pets are secured during service"
    ],
    videoId: "3tz3QL6tcj4"
  },
  power_rake: {
    name: 'Power Rake',
    title: "Prepare for Your Power Rake Service",
    items: [
      "Mark any sprinkler heads that are above grade",
      "Remove leaves and debris from lawn",
      "Unlock gates for yard access",
      "Ensure lawn is dry and free of snow"
    ],
    videoId: "qWLCfsdrkaU"
  },

  // ----------- NEW SERVICES ------------
  fertilization_liquid_feed_only: {
    name: 'Fertilization: Liquid Feed Only',
    title: "Fertilization: Liquid Feed Only",
    items: [
      "Remove pet waste, toys, and debris from the lawn",
      "Unlock gates to allow access to service areas",
      "Avoid mowing the day of service if possible",
      "Secure pets indoors during application"
    ],
    videoId: ""
  },
  lawn_herbicide_application_pre_emergent: {
    name: 'Lawn Herbicide Application: Pre-Emergent',
    title: "Lawn Herbicide Application: Pre-Emergent",
    items: [
      "Remove pet waste, toys, and debris from the lawn",
      "Unlock gates to allow access to service areas",
      "Secure pets indoors during application"
    ],
    videoId: "EYAp-9x0cNI"
  },
  lawn_herbicide_application_post_emergent: {
    name: 'Lawn Herbicide Application: Post-Emergent',
    title: "Lawn Herbicide Application: Post-Emergent",
    items: [
      "Remove pet waste, toys, and debris from the lawn",
      "Unlock gates to allow access to service areas",
      "Avoid mowing 24 hours before treatment",
      "Secure pets indoors during application"
    ],
    videoId: "QC86i8x37vQ"
  },
};